import { SubprogramService } from '@modules/subprogram/subprogram-service';
import { routerAsync } from '@/app-module';
import { i18n } from '@shared/i18n';
import Errors from '@shared/error/errors';
import Message from '@shared/message/message';

export default {
  namespaced: true,
  
  state: {
    findLoading: false,
    saveLoading: false,
    record: null,
    rows: [],
    loading: false,
  },

  getters: {
    record: (state) => state.record,
    findLoading: (state) => !!state.findLoading,
    saveLoading: (state) => !!state.saveLoading,
    loading: (state) => state.loading,
    rows: (state) => state.rows || [],
  },

  mutations: {
    RESET(state) {
      state.findLoading = false;
      state.saveLoading = false;
      state.record = null;
    },

    FIND_STARTED(state) {
      state.record = null;
      state.findLoading = true;
    },

    FIND_SUCCESS(state, payload) {
      state.record = payload;
      state.findLoading = false;
    },

    FIND_ERROR(state) {
      state.record = null;
      state.findLoading = false;
    },

    CREATE_STARTED(state) {
      state.saveLoading = true;
    },

    CREATE_SUCCESS(state) {
      state.saveLoading = false;
    },

    CREATE_ERROR(state) {
      state.saveLoading = false;
    },

    UPDATE_STARTED(state) {
      state.saveLoading = true;
    },

    UPDATE_SUCCESS(state) {
      state.saveLoading = false;
    },

    UPDATE_ERROR(state) {
      state.saveLoading = false;
    },

    FETCH_STARTED(state) {
      state.loading = true;
    },

    FETCH_SUCCESS(state, payload) {
      state.loading = false;
      state.rows = payload.rows;
    },

    FETCH_ERROR(state) {
      state.loading = false;
      state.rows = [];
    },

    DESTROY_STARTED(state) {
      state.loading = true;
    },

    DESTROY_SUCCESS(state) {
      state.loading = false;
    },

    DESTROY_ERROR(state) {
      state.loading = false;
    },
  },

  actions: {
    doNew({ commit }) {
      commit('RESET');
    },

    async doFindRound({ commit }, {id, subprogramId, propertyId, subpropertyId, programId}) {
      try {
        commit('FIND_STARTED');

        const record = await SubprogramService.findRound(id, subprogramId, {type: 'program', propertyId, subpropertyId, programId});

        commit('FIND_SUCCESS', record);
      } catch (error) {
        Errors.handle(error);
        commit('FIND_ERROR');
      }
    },

    async doCreateRound({ commit }, { subprogramId, values, propertyId, subpropertyId, programId }) {
        try {
            commit('CREATE_STARTED');
          
            await SubprogramService.createRound(subprogramId, values, {type: 'program', propertyId, subpropertyId, programId});

            commit('CREATE_SUCCESS');
            Message.success(i18n('entities.subprogram.nba.rounds.create'));

            routerAsync().go(-1);
        } catch (error) {
            Errors.handle(error);
            commit('CREATE_ERROR');
        }
    },

    async doUpdateRound({ commit }, { id, subprogramId, values, propertyId, subpropertyId, programId }) {
      try {
        commit('UPDATE_STARTED');
        await SubprogramService.updateRound(id, subprogramId, values, {type: 'program', propertyId, subpropertyId, programId});
        routerAsync().go(-1);

        commit('UPDATE_SUCCESS');
        Message.success(i18n('entities.subprogram.nba.rounds.update'));
      } catch (error) {
        Errors.handle(error);
        commit('UPDATE_ERROR');
      }
    },

    async doFetchRound({ commit }, { subpropertyId, programId, subprogramId }) {
      try {
        commit('FETCH_STARTED');

        const response = await SubprogramService.listRound(subpropertyId, programId, subprogramId);
        
        commit('FETCH_SUCCESS', {
          rows: response
        });
      } catch (error) {
        Errors.handle(error);
        commit('FETCH_ERROR');
      }
    },

    async doDestroyRound({ commit, dispatch }, {id, subprogramId, propertyId, subpropertyId, programId}) {
      try {
        commit('DESTROY_STARTED');
        await SubprogramService.destroyRound([id], subprogramId, {type: 'program', propertyId, subpropertyId, programId});

        commit('DESTROY_SUCCESS');

        Message.success(i18n('entities.subprogram.nba.rounds.destroy'));
        dispatch('doFetchRound', {
          subpropertyId: subpropertyId,
          programId: programId,
          subprogramId: subprogramId
        });
      } catch (error) {
        Errors.handle(error);
        commit('DESTROY_ERROR');
      }
    },
  },
};